export const i18n = {
  catalogue: {
    paymentResult: {
      bank: {
        instructions:
          "Por favor realiza un pago via SINPE por <0>{{amount}}</0> a:",
      },
    },
  },
};
